import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-apply-asset',
    templateUrl: './apply-asset.component.html',
    styleUrls: ['./apply-asset.component.scss'],
    standalone: false
})
export class ApplyAssetComponent implements OnInit {

  constructor() { }


  loanId: number;
  requesterId: number;
  approverId: number;
  amount: number;
  remark: string;
  approved: boolean;


  ngOnInit() {
  }

  createAssetRecord() {
    const xhr = new XMLHttpRequest();
    const url = "http://localhost:10080/api/v1/asset";
    xhr.open("POST", url, true);
    xhr.setRequestHeader("Content-type", "application/json");
    xhr.onreadystatechange = function () {
      if (xhr.readyState == 4 && xhr.status == 200) {
      }
    }
    const data = JSON.stringify({
      "loanId": this.loanId,
      "requesterId": this.requesterId,
      "approverId": this.approverId,
      "amount": this.amount,
      "remark": this.remark,
      "approved": this.approved
    });
    xhr.send(data);

  }


  getAllAssets() {

    const xhr = new XMLHttpRequest();
    const url = "http://localhost:10080/api/v1/assets";
    xhr.open("GET", url, true);
    xhr.setRequestHeader("Content-type", "application/json");
    xhr.onreadystatechange = function () {
      if (xhr.readyState == 4 && xhr.status == 200) {
        const json = JSON.parse(xhr.responseText);
        // console.log(this.responseText);
      }
    }
    xhr.send();

  }
  reset() {

  }
}
